const isDevEnv = () =>
  window.location.hostname.includes(".ngrok") ||
  window.location.hostname === "localhost" ||
  process.env.REACT_APP_ENV === "development" ||
  process.env.REACT_APP_ENV === "staging"

export default isDevEnv

export { isDevEnv }
